'use strict';

export const USER_COLLECTION = 'users';
export const API_KEYS_COLLECTION = 'api-key-chain';



// WEBPACK FOOTER //
// ./src/js/auth/domain/config.js